import { useContext } from 'react';
import { SaveContext } from "./SaveContext.js";
/**
 * Get the save() function and its status
 *
 * Used in forms.
 *
 * @example
 *
 * const {
 *     save,
 *     saving
 * } = useSaveContext();
 */
export var useSaveContext = function (_props) {
    return useContext(SaveContext);
};
//# sourceMappingURL=useSaveContext.js.map